class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
  event.preventDefault();
  
  const isCurrentlyOpen = event.target.closest('details').hasAttribute('open');
  
  if (isCurrentlyOpen) {
    this.close();
  } else {
    // Detectar si es móvil
    const isMobile = window.innerWidth <= 990 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (isMobile) {
      // EN MÓVIL: preferir el overlay de Searchanise; si no está disponible,
      // caer SIEMPRE al modal nativo (nunca dejar al cliente sin buscador).
      this.activateSearchaniseOnly(event);
    } else {
      // Desktop: abrir modal nativo normalmente
      this.open(event);
    }
  }
}

activateSearchaniseOnly(event) {
  // 1. API oficial del widget de Searchanise (abre su overlay fullscreen)
  try {
    if (window.snize && typeof window.snize.openSearch === 'function') {
      window.snize.openSearch();
      return;
    }
  } catch (e) { /* seguir al fallback */ }

  // 2. FALLBACK: modal nativo del tema. Searchanise se engancha igual al input
  // (clase snize-input-style), y si la app no cargó, el predictivo nativo de
  // Shopify funciona solo. El cliente SIEMPRE tiene un buscador.
  this.open(event);
}


  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
